import React from 'react';
import {connect} from 'react-redux';
import {getLabels} from '../../laws/selectors';
import BreadCrumb from '../components/BreadCrumb';
import {printQueue} from '../../../constants/public-routes';
import Link from '../../routing/components/Link';
import {FormattedMessage} from 'react-intl';
import {getLastQuery} from '../../routing/selectors';

class BreadcrumbContainer extends React.Component {
  constructor(props) {
    super(props);

  }

  render() {
    const {params, routes, children, labels, intl, printQueueCount, lastQuery} = this.props;

    let modifiedRoutes = [].concat(routes);

    if (lastQuery) {
      let queryRoute = {
        path: '/',
        link: lastQuery,
        name: 'query'
      };
      let diaIndex = null;
      modifiedRoutes.forEach((route, index) => {
        if (route.name === 'dia') {
          diaIndex = index;
        }
      });
      if (diaIndex) {
        modifiedRoutes.splice(diaIndex, 0, queryRoute);
      }
    }
    return (
      <div>
        <BreadCrumb params={params} routes={modifiedRoutes} labels={labels}/>
        <p className="breadcrumb" style={{lineHeight: '24px'}}>{printQueueCount > 0 ?
          <Link url={printQueue(intl.locale)}><FormattedMessage id="printQueue"/>&nbsp;<span className="badge"><i
            className="glyphicon glyphicon-print"/>&nbsp;{printQueueCount}</span></Link> : <span>&nbsp;</span>}</p>
        {children}
      </div>
    );
  }
}

BreadcrumbContainer.propTypes = {
  children: React.PropTypes.node,
  lastQuery: React.PropTypes.string,
  params: React.PropTypes.object.isRequired,
  routes: React.PropTypes.array.isRequired,
  labels: React.PropTypes.object,
  printQueueCount: React.PropTypes.number,
  intl: React.PropTypes.object
};


function mapStateToProps(state) {
  const {intl, printQueue} = state;
  let labels = getLabels(state);
  let lastQuery = getLastQuery(state);

  return {
    labels,
    intl,
    lastQuery,
    printQueueCount: printQueue.items ? printQueue.items.length : 0
  };
}

export default connect(mapStateToProps)(BreadcrumbContainer);



/** WEBPACK FOOTER **
 ** ./src/modules/breadcrumb/containers/BreadcrumbContainer.js
 **/